module.exports = __webpack_public_path__ + "static/media/lease6_img1.f2e2ad6b.jpg";